import React, {useState} from 'react';

import {HomeHero} from '../components/HomeHero';
import {NavBar} from '../components/NavBar';
import {AmenitiesBoxes} from '../components/AmenitiesBoxes';
import {FAQ} from '../components/FAQ';
import {NumbersBoxes} from '../components/NumbersBoxes';
import {Footer} from '../components/Footer';
import {Promo1} from '../components/Promo1';
import {PhotoCarousel} from '../components/PhotoCarousel';

export const Home = () => {
    return (
      <>
      <NavBar/>
       <HomeHero/>
       <NumbersBoxes/>
       <Promo1/>
       <PhotoCarousel/>
       <AmenitiesBoxes/>
       <FAQ/>
       <Footer/>
        </>
    );
  };